import * as React from "react";

import GenModal from "../../Gen/Modal";
import GenButton from "../../Gen/Button";

import AddToList from "../AddTo/List";

import { documentDisplayTitle } from "../../../src/document_display_title";

const ALLOWED_ROLE_NAMES = ["Faculty", "Manager", "Partner", "ReelDx_Faculty"];
const ADMIN_NAMES = ["Manager"];

interface DocAddToButtonProps {
  document: DocumentSnakeModel;
  currentUser?: CurrentUser | UserSnakeModel;
  currentRoleDefinition?: CurrentRoleDefinition | RoleDefinitionSnakeModel;
  categoryId?: number;
}

interface DocAddToButtonState {
  modalOpen: boolean;
}

export default class AddToButton extends React.Component<DocAddToButtonProps, DocAddToButtonState> {
  state = {
    modalOpen: false,
  };

  handleToggleModalOpen = () =>  {
    this.setState({
      modalOpen: !this.state.modalOpen,
    });
  };

  render() {
    const {
      document,
      currentUser,
      currentRoleDefinition,
      categoryId,
    } = this.props;

    const isUserAllowed = currentUser?.is_admin || (currentRoleDefinition && ALLOWED_ROLE_NAMES.includes(currentRoleDefinition?.name));
    if (!isUserAllowed) { return null; }

    const canAddToUnownedDocumentSets = currentUser?.is_admin || (currentRoleDefinition && ADMIN_NAMES.includes(currentRoleDefinition?.name));

    return(
      <>
        <button title="Add to course" className="bg-sky-600 hover:bg-sky-500 p-2 button add-to-button" onClick={this.handleToggleModalOpen}>
          <i className="fa fa-plus" />
        </button>

        <GenModal open={this.state.modalOpen}>
          <div className="gen-modal-panel add-to-modal">
            <div className="add-to-button-modal-header">
              <h1>Adding Case to Course</h1>

              <div className="gen-button-right-group">
                <GenButton
                  name="Close"
                  highlighted
                  small
                  onClick={this.handleToggleModalOpen}
                />
              </div>
            </div>

            <div className='case-info'>
              <img
                src={document.cover_image}
                alt={`Case ${document.id} Cover Image`}
              />

              <h5>{documentDisplayTitle(document)}</h5>
            </div>

            <AddToList
              documentId={document.id}
              canAddToUnownedDocumentSets={canAddToUnownedDocumentSets}
              userId={currentUser?.id}
              showsOwnershipCheckbox
              categoryId={categoryId}
            />
          </div>
        </GenModal>
      </>
    );
  }
}
